import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20cream%20paper%20texture%20with%20interwoven%20rust%20red%20threads%20and%20faded%20ink%20brush%20strokes%2C%20soft%20directional%20light%2C%20minimal%20artistic%20composition%2C%20muted%20earth%20tones%2C%20subtle%20depth%20and%20grain&width=1600&height=600&seq=suying-cta-threads-01&orientation=landscape"
          alt="档案线索交织的抽象纸质纹理背景"
          title="提交黑料网红考古线索"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-950/85"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-14 md:py-20 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
        <div className="max-w-2xl">
          <span className="text-xs tracking-[0.22em] text-secondary-200">SUBMIT A LEAD</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            手里有还没被扒干净的旧材料？
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-100/85 leading-relaxed">
            把公开链接、旧稿截图或时间线索交给我们，档案组会按流程核对来源，确认后立项归档。
            注意：请勿提交任何非公开的个人隐私信息。
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/contact"
            className="px-6 py-3 rounded-md bg-background-50 text-primary-950 text-sm font-medium hover:bg-background-100 transition-colors text-center whitespace-nowrap"
          >
            提交考古线索
          </Link>
          <Link
            to="/archive"
            className="px-6 py-3 rounded-md border border-background-50/50 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors text-center whitespace-nowrap"
          >
            先翻翻已有档案
          </Link>
        </div>
      </div>
    </section>
  );
}